<template>
  <div class="listGroup">
    <div class="listGroup__listings">
      <div class="listview">
        <table>
          <thead class="none">
            <tr>
              <td class="listview__title items">ITEMS</td>
              <td class="listview__title placement">PLACEMENT</td>
              <td class="listview__title dailyvisitor">DAILY VISITOR</td>
              <td class="listview__title price">PRICE / DAY</td>
              <td class="save"></td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in items" :key="index" @click.stop="listClick(item)" class="content">
              <td class="items">
                <div class="item">
                  <img v-if="item.thumbnail_square" :src="item.thumbnail_square" alt="">
                  <img v-else :src="`/img/notfound/img-placeholder_square.jpg`" alt="">
                  <div class="stack">
                    <span class="title">{{item.location_name}}</span>
                    <span class="location">
                      {{item.property_type_display}} . {{item.city_name}}
                    </span>
                    <span class="price-mobile">{{item.price | formatMoney}}</span>
                  </div>
                </div>
              </td>
              <td class="placement none"><span>{{item.placement}}</span></td>
              <td class="visitor none"><span>{{item.audience_daily}} people</span></td>
              <td class="price none"><span>{{item.price | formatMoney}}</span></td>
              <td class="icon-list" @click.stop="removeDevice(item)">
                <adx-loading-secondary v-if="isLoading.includes(item.id)" />
                <i v-if="!isLoading.includes(item.id)" class="adx-ic_close"></i>
              </td>
            </tr>
            <tr v-if="items.length > 5">
              <td colspan="5" class="showall subhead">
                Show All
              </td>
            </tr>
          </tbody>
        </table>
        <div class="emptyState">
          <adx-empty-selection v-if="isEmpty"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingSecondary from '@/components/Loading/Secondary'

import api from '@/api/'
import { apiV2 } from '@/api/urls'
import { savedChannel } from '@/lib/types'

export default {
  name: 'adx-list-item-collection-editor',
  components: {
    'adx-loading-secondary': LoadingSecondary
  },
  props: {
    items: {
      required: false
    },
    headers: {
      required: false
    },
    category: {
      required: false
    },
    menuList: {
      required: false
    },
    page: {
      required: false
    },
    isAction: {
      required: false
    },
    loading: {
      required: false
    },
    title: {
      required: false
    }
  },
  data() {
    return {
      isHover: null,
      isEmpty: false,
      saved: [],
      isLoading: []
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    removeDevice(item) {
      (async () => {
        this.isLoading.push(item.id)
        const category = savedChannel[this.category]
        let data = {
            'device_id': item.id,
            'channel_type': category
        }
        const response = await api.patch(apiV2.collectionRemoveDevice(this.$route.params.id), data, { needToken: true })
        this.$emit('reloadData', this.category, item.id)
        this.isLoading = []
      })();
    },
    setID(id){

    },
    listClick(item) {
      this.$emit('item-clicked', item)
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>